module.exports = __webpack_public_path__ + "static/img/img_weibo_code.c6805f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_weibo_code.png
// module id = CQNN
// module chunks = 5